import styled from 'styled-components';
const percentageSize = 1.3;

export const Background = styled.div`
  position: ${({ active }) => (active ? 'fixed' : 'initial')};
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(51, 51, 51, 0.6);
`;

export const ModalContainer = styled.div`
  position: fixed;
  color: white;
  display: ${({ modalOpen }) => (modalOpen ? 'flex' : 'none')};
  flex-direction: column;
  background-color: #333c;
  border-radius: 10px;
  z-index: 15;
  bottom: ${({ center, altura }) => (center ? '50%' : `calc(${altura}px - 30px)`)};
  /* bottom: calc(${({ altura }) => altura}px - 30px); */
  /* transform: translateY(-50%); */
  transform: ${({ center }) => (center ? 'translateY(50%)' : 'translateY(-50%)')};
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: ${({ info }) => (info ? '580px' : '650px')};

  /* @media screen and (max-width: 1300px) {
    bottom: calc(${({ altura }) => altura}px - 180px);
  } */

  @media screen and (max-width: 768px) {
    transform: translateY(0%);
    width: auto;
    border-radius: 0;
    bottom: 0;
    height: fit-content;
    top: auto;
  }
`;

export const ContentWrapper = styled.div`
  padding: 10px;
`;
export const ShareBar = styled.nav`
  background-color: #333;
  /* box-shadow: 0 4px 7px -2px #252525; */
  display: flex;
  align-items: center;
  z-index: 3;
  height: 30px;
  border-radius: 10px 10px 0px 00px;

  @media screen and (max-width: 768px) {
    border-radius: 0;
  }
`;

export const ShareBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 6px;
  align-items: center;
`;

export const BarTitleWrappper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  height: 15px;
`;

export const CloseBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  position: absolute;
  right: 1%;
`;

export const BarBtn = styled.button`
  background-color: transparent;
  border: 0px;
  margin: 0px;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BarTitle = styled.span`
  color: white;
  padding-left: 25px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  }
`;

export const ModalIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 18 * percentageSize : 18,
  fill: '#fff'
}))``;
